import { render } from "./App.vue?vue&type=template&id=6af65fba&lang=pug"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/styles/app.sass?vue&type=style&index=0&lang=sass"
import "@/styles/main.sass?vue&type=style&index=1&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__